import React from 'react';
import { getContentByUrl } from '../../../../services/api';
import { PropTypes } from 'prop-types';
import { EmbeddedContent } from './EmbeddedContent';
import { EmbeddedVideo } from './EmbeddedVideo';
import * as youtubeStyles from '../../../../styles/widgets/youtube.module.scss';
import {altNN} from '../../../../utils/parsing';

export const Embedded = ({
  elem,
  contentUrl,
  index,
  playingVideoIndex,
  setPlayingVideoIndex,
}) => {
  if (!elem)
    return;
  const url = !elem ? contentUrl : elem.content_link;
  const [content, setContent] = React.useState(null);
  React.useEffect(() => {
    let unmounted = false;
    const fetchContent = async () => {
      const contentResponse = await getContentByUrl(url);
      if (!unmounted) {
        setContent(contentResponse?.data);
      }
    };

    fetchContent();
    return () => (unmounted = true);
  }, [url]);

  const mapContent = {
    video: (
      <EmbeddedVideo
        backgroundColor={
          content?.providerName?.toLowerCase() === 'vimeo' ? 'black' : 'inherit'
        }
        content={content}
        index={index}
        playingVideoIndex={playingVideoIndex}
        setPlayingVideoIndex={setPlayingVideoIndex}
      />
    ),
    rich: (
      <EmbeddedContent
        content={content}
        index={index}
        playingVideoIndex={playingVideoIndex}
        setPlayingVideoIndex={setPlayingVideoIndex}
      />
    ),
    photo: (
      <EmbeddedPhoto title={content?.title}
        url={content?.url}
      />
    ),
  };

  const getComponentByTypeAndProvider = () => {
    const contentByType = mapContent[content?.type];
    return contentByType ? contentByType : null;
  };

  return getComponentByTypeAndProvider();
};

const EmbeddedPhoto = ({ url, title }) => {
  return (
    <div className={youtubeStyles.bloc}
      role="presentation"
    >
      <img alt={altNN(title)}
        src={url}
      />
    </div>
  );
};

EmbeddedPhoto.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
};

Embedded.propTypes = {
  contentUrl: PropTypes.string,
  elem: PropTypes.object,
  index: PropTypes.number,
  playingVideoIndex: PropTypes.number,
  setPlayingVideoIndex: PropTypes.func,
};